import { render } from "./copy-right.vue?vue&type=template&id=7bbaff27"
import script from "./copy-right.vue?vue&type=script&lang=js"
export * from "./copy-right.vue?vue&type=script&lang=js"

import "./copy-right.vue?vue&type=style&index=0&id=7bbaff27&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/copyRight/copy-right.vue'],['render',render],['__file',"copy-right.vue"]])

export default __exports__